import { Link } from "react-router-dom";
import { movies } from "@/mocks/movies";

interface CategorySidebarProps {
  type: string;
  activeGenre: string;
  onGenre: (value: string) => void;
}

export default function CategorySidebar({
  type,
  activeGenre,
  onGenre,
}: CategorySidebarProps) {
  const movieCount = movies.filter((m) => m.type === "movie").length;
  const tvCount = movies.filter((m) => m.type === "tvseries").length;

  const genreCount = new Map<string, number>();
  movies
    .filter((m) => m.type === type)
    .forEach((m) => {
      m.genres.forEach((g) => {
        genreCount.set(g, (genreCount.get(g) || 0) + 1);
      });
    });
  const genres = Array.from(genreCount.entries()).sort((a, b) => b[1] - a[1]);

  const categories = [
    { key: "movie", label: "国产电影", count: movieCount, icon: "ri-film-line" },
    { key: "tvseries", label: "国产电视剧", count: tvCount, icon: "ri-tv-2-line" },
  ];

  return (
    <aside className="w-full lg:w-64 shrink-0 flex flex-col gap-5">
      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3">
          分类导航
        </h2>
        <nav className="flex flex-col gap-1">
          {categories.map((category) => (
            <Link
              key={category.key}
              to={`/category/${category.key}`}
              className={`flex items-center justify-between px-3 py-2.5 rounded-md text-sm transition-colors ${
                category.key === type
                  ? "bg-primary-50 text-primary-600 font-medium"
                  : "text-foreground-700 hover:bg-background-100"
              }`}
            >
              <span className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className={category.icon}></i>
                </span>
                {category.label}
              </span>
              <span className="text-xs text-foreground-400">{category.count}</span>
            </Link>
          ))}
        </nav>
      </div>

      <div className="rounded-lg bg-background-50 border border-background-200 p-4">
        <h2 className="font-heading text-base font-semibold text-foreground-950 mb-3">
          热门题材
        </h2>
        <div className="flex flex-wrap gap-2">
          <button
            type="button"
            onClick={() => onGenre("全部")}
            className={`px-2.5 py-1 rounded-md text-xs cursor-pointer transition-colors ${
              activeGenre === "全部"
                ? "bg-secondary-500 text-background-50"
                : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200"
            }`}
          >
            全部
          </button>
          {genres.map(([genre, count]) => (
            <button
              key={genre}
              type="button"
              onClick={() => onGenre(genre)}
              className={`px-2.5 py-1 rounded-md text-xs cursor-pointer transition-colors ${
                activeGenre === genre
                  ? "bg-secondary-500 text-background-50"
                  : "bg-secondary-100 text-secondary-800 hover:bg-secondary-200"
              }`}
            >
              {genre} {count}
            </button>
          ))}
        </div>
      </div>
    </aside>
  );
}